// Module
var code = "<abx-schedule-list class=\"flat\" abx-building=\"vm.building\" abx-models=\"vm.schedules\" abx-fetch=\"vm.fetchSchedules(skip, limit)\" abx-fetch-all=\"vm.fetchAllSchedules(limit)\" abx-status=\"vm.status\" abx-create-options=\"vm.createOptions\"> </abx-schedule-list> ";
// Exports
module.exports = code;